<div class="images-container">
  <h3>Carousel Images</h3>

  <div class="table-toolbar">
    <div>
      <button matButton="filled" (click)="add()">Add</button>
    </div>

  </div>

  @if(store.isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }



  <div class="table-container mat-elevation-z8">
    <table mat-table [dataSource]="dataSource">

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="w-10p"></th>
        <td mat-cell *matCellDef="let row; let i = index">

          {{i + 1}}

        </td>
      </ng-container>

      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let row">
            <img [ngSrc]="row.image" height="40" width="40" alt="carousel image">
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th mat-header-cell *matHeaderCellDef  class="w-15p"> Last Updated </th>
        <td mat-cell *matCellDef="let row"> {{row.lastUpdated | date:'MM/dd/yyyy' }} </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef  class="w-10p"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon (click)="edit(row)" class="pointer mt-5">edit</mat-icon>
          <mat-icon (click)="confirmDelete(row)" class="pointer mt-5">delete</mat-icon>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>


  </div>

</div>
